import Pagination from "../../shared/Pagination/Pagination"
import DataTable from "../../shared/DataTable/DataTable"
const Table = (props) => {
    const { columns, rows, height, rowClass, dynamicClass, rowHeight, PerPage, PageNo, Counts, TotalPages, onRowsChange, headerRowHeight,
        handlePageClick, PreviousPage, handleFingByCreteria, NextPage, Key, Name, hidePagination, isLoading, hideColClass, colPopup, TableName, bottomSummaryRows, RowsDD, handleSelectData, LoadData, ClearSearch } = { ...props }
    return (
        <>
            {/* <div className='h-100'> */}
            {/* {isLoading ? <Loader/> : null} */}
            <DataTable
                columns={columns}
                key={Key}
                rows={rows}
                height={height}
                rowClass={rowClass}
                dynamicClass={dynamicClass}
                rowHeight={rowHeight}
                selectedRows={props.selectedRows}
                onSelectedRowsChange={props.onSelectedRowsChange}
                isLoading={isLoading}
                hideColClass={hideColClass}
                colPopup={colPopup}
                onRowsChange={onRowsChange}
                headerRowHeight={headerRowHeight}
                TableName={TableName}
                bottomSummaryRows={bottomSummaryRows}
                rowKeyGetter={props.rowKeyGetter}
            />
            {/* {rows.length < 1 && (
                <div
                    style={{
                    width: ' 180px',
                    padding: '8px 16px',
                    position: 'absolute',
                    bottom: '8px',
                    right: '8px',
                    color: 'white',
                    lineHeight: '35px',
                    background: 'rgb(0 0 0 / 0.6)',
                    }}
                >
                    No more rows
                </div>
                )} */}
            {/* </div> */}

            {!hidePagination && (
                <Pagination
                    PerPage={PerPage}
                    PageNo={PageNo}
                    TotalPages={TotalPages}
                    Counts={Counts}
                    handlePageClick={handlePageClick}
                    PreviousPage={PreviousPage}
                    handleFingByCreteria={handleFingByCreteria}
                    NextPage={NextPage}
                    RowsDD={RowsDD}
                    selectedRows={props.selectedRows}
                    handleSelectData={handleSelectData}
                    disableInput={props.disableInput}
                    LoadData={LoadData}
                    Key={Key}
                    ClearSearch={ClearSearch}
                />
            )}
        </>
    )
}

export default Table